import React, { useMemo } from "react";
import { getAgendaCobranzaEmailDisplayLines } from "src/utils/collectionEmailContacts";

export default function CobranzaClientEmailsDisplay({ agenda }) {
  const lines = useMemo(() => getAgendaCobranzaEmailDisplayLines(agenda), [agenda]);

  if (!lines.length) {
    return <span>—</span>;
  }

  if (lines.length === 1) {
    return <span className="cf-gestion-client-emails__single">{lines[0].label}</span>;
  }

  return (
    <ul className="cf-gestion-client-emails">
      {lines.map((line) => (
        <li
          key={`${line.email}-${line.isPrimary ? "p" : "s"}`}
          className={line.isPrimary ? "cf-gestion-client-emails__item--primary" : undefined}
        >
          {line.label}
        </li>
      ))}
    </ul>
  );
}
